import React from "react";

// Official Streamline360 logo (horizontal wordmark + mark), transparent PNG/WEBP.
// Aspect-ratio-locked so it never stretches when the parent sets both height & width.
const LOGO_SRC = "/streamline360-logo.png";
const LOGO_RATIO = "260 / 56"; // native wordmark proportions

export function Logo({ className = "", imgClass = "h-7" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Streamline360"
      data-testid="brand-logo"
      style={{ aspectRatio: LOGO_RATIO }}
      className={`${imgClass} w-auto select-none object-contain ${className}`}
    />
  );
}

export const LogoMark = Logo;
